// Use the same plane for all buttons to increase performance
import { Mesh, MeshBasicMaterial, PlaneGeometry } from "three";
import { InteractionFacet, PrimitiveShape, ShowTooltipsBehavior, SwitchTransformModeAction, TooltipInfoFacet, TooltipPlacement, UpdateFacetOnModelMessage, UTILITY_ROOM_UID, RemoveSubModelMessage, DeleteModelMessage } from "flavr-common";
import { RemoveCollisionShapeMessage, CreateCollisionShapeMessage } from "@messages/selection/CollisionShapeMessages";
import { useExternalMessages, modelPool } from "@modules/model";
const PLANE_GEOMETRY = new PlaneGeometry(1, 1);
export class GizmoButton {
    constructor(name, tooltip, textures, offsetX) {
        this.name = name;
        this.tooltip = tooltip;
        this.active = true;
        this.modelUid = -1;
        this.materials = textures.map((texture) => new MeshBasicMaterial({
            map: texture,
            transparent: true,
            depthTest: false,
            depthWrite: false
        }));
        this.mesh = new Mesh(PLANE_GEOMETRY, this.materials[0]);
        this.mesh.position.x = offsetX;
        this.mesh.frustumCulled = false;
    }
    /**
     * Change the appearance to indicate if the button is clickable or not
     */
    setActive(active) {
        this.active = active;
        const material = this.mesh.material;
        material.opacity = active ? 1 : 0.5;
    }
    /**
     * Change the appearance to indicate that this button is currently selected
     */
    setSelected(selected) {
        const material = this.mesh.material;
        const color = selected ? 0xff0000 : 0xffffff;
        material.color.setHex(color);
    }
    createButtonModel(messages) {
        const props = useExternalMessages(messages);
        const utilityRoom = modelPool.getRoomOrThrow(UTILITY_ROOM_UID);
        const model = modelPool.createModel(this.name, utilityRoom, props);
        this.modelUid = model.getUID();
        // Create model and it's rigid body
        messages.push(new CreateCollisionShapeMessage(PrimitiveShape.Box, this.modelUid, true));
        messages.push(new UpdateFacetOnModelMessage(this.modelUid, new TooltipInfoFacet(this.tooltip, undefined, undefined, TooltipPlacement.ABOVE_MODEL)));
        this.updateInteraction(messages);
    }
    updateButtonModel() {
        const model = modelPool.getModel(this.modelUid);
        if (model === undefined)
            return;
        model.setPosition(this.mesh.position);
        model.setOrientation(this.mesh.quaternion);
        model.setScale(this.mesh.scale);
    }
    removeButtonModel(messages) {
        if (this.modelUid === -1)
            return;
        messages.push(new RemoveSubModelMessage(this.modelUid));
        messages.push(new DeleteModelMessage(this.modelUid));
        messages.push(new RemoveCollisionShapeMessage(this.modelUid));
        this.modelUid = -1;
    }
    updateTransform(position, orientation, scale, cameraUp, cameraRight, offset) {
        const newPosition = position.clone().add(cameraUp).sub(cameraRight).sub(cameraRight.clone().multiplyScalar(offset));
        this.mesh.position.copy(newPosition);
        this.mesh.quaternion.copy(orientation);
        this.mesh.scale.copy(scale);
        this.updateButtonModel();
    }
    updateInteraction(messages) {
        // When clicking on the gizmo perform the respective
        // Gizmo button action
        const clickActions = [];
        if (this.active) {
            clickActions.push(new SwitchTransformModeAction(this.name));
        }
        messages.push(new UpdateFacetOnModelMessage(this.modelUid, new InteractionFacet({
            behaviors: [new ShowTooltipsBehavior()],
            onClick: clickActions
        })));
    }
}
